import dayjs from 'dayjs';

export const toDateFormat = (dateString?: string, format = 'DD MMM YYYY') => {
  if (!dateString) return '';

  return dayjs(dateString).format(format);
};
